import { Button, Col, Form, Input, Modal, Row, DatePicker } from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectShortTermGoalsConflict, setShortTermGoalsConflict } from "slices/dashboardSlice";
import { getTextWidth, wrapTextToWidth } from "utils/shortTermGoals";
// TimelineCardPopup component
const TimelineCardPopup = ({
  id,
  title,
  dueTime,
  description,
  startTime,
  position,
  onSubmit,
  setFormOpen,
  onDelete,
  setPopupVisible,
  isPopupVisibleRef,
}) => {
  const [showEditPopup, setShowEditPopup] = useState(false); // Track popup visibility
  const dispatch = useDispatch();
  const conflict = useSelector(selectShortTermGoalsConflict)

  useEffect(() => {
    setFormOpen(false)
  }, [])

  useEffect(() => {
    if(conflict){
      setShowEditPopup(true)
    }
  }, [conflict])
  

  const getDueDays = (dueTime) => {
    if (!dueTime || !moment(dueTime).isValid()) {
      return `Set a new goal date!`;
    }
    const today = moment();
    const diff = moment(dueTime).diff(today, "days");
    const day = Math.abs(diff) === 1 ? "day" : "days";
    if (diff < 0) {
      return `Overdue by ${Math.abs(diff)} ${day}!`;
    } else if (diff === 0) {
      return "Due today";
    } else {
      return `Due in ${diff} ${day}`;
    }
  };

  const text = description;
  const font = "15px AvenirBook";
  const maxWidth = getTextWidth(`${moment(startTime).format('MMMM D, YYYY')} - ${moment(dueTime).format('MMMM D, YYYY')}`);

  const resultText = wrapTextToWidth(text, maxWidth, font);
  console.log('sss resultText', resultText, maxWidth)

  return (
    <div
      ref={isPopupVisibleRef}
      style={{
        position: "absolute",
        top: position.top + 180, // Add a little offset to position below the clicked item
        left: position.left - 200, // Add offset for better visual alignment
        backgroundColor: "white",
        border: "1px solid #ccc",
        padding: "10px",
        borderRadius: "8px",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 100, // Ensure the popup is above other elements
        width: "350px",
        width: "max-content"
      }}
    >
      <div
        className="title-bar"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          columnGap: "15px",
        }}
      >
        <h3 style={{ color: "#199094", fontSize: "18px", marginBottom: "0px" }}>{title}</h3>
        <button
          style={{
            border: "none",
            borderRadius: "50%",
            textAlign: "center",
            backgroundColor: "transparent",
            paddingRight: "0px",
          }}
          onClick={() => {
            dispatch(setShortTermGoalsConflict(false));
            setShowEditPopup(true); // Show EditCardPopup
            setFormOpen(false)
          }}
        >
          <img
            src="https://django-woken-static.s3.amazonaws.com/static/media/edit-timeline.svg"
            style={{ width: "100%", height: "100%" }}
            alt="edit"
          />
        </button>
      </div>

      <div style={{ fontWeight: "600", marginBottom: "15px", width: "max-content" }}>Goal</div>
      {
        resultText.map((item, index) => {
          let margin = "1rem";
          
          if(resultText.length > 1){
            margin = 0
            if(index === resultText.length-1){
              margin = "1rem"
            }
          }
          
          return (
            <p style={{ width: "max-content", marginBottom: margin}}>{item}</p>
          )
        })
      }

      <div
        style={{
          backgroundColor: "rgb(244 208 187)",
          color: "black",
          padding: "5px 10px",
          borderRadius: "20px",
          display: "flex",
          columnGap: '8px',
          alignItems: "center",
          width: "max-content"
        }}
      >
        <img
          src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/inprogressLarge.svg"
          style={{ width: "23px", height: "23px" }}
        />
        <span style={{ fontSize: "14px", fontWeight: "600" }}>
          {/* {getDueDays(dueTime)} */}
          {
            `${moment(startTime).format('MMMM D, YYYY')} - ${moment(dueTime).format('MMMM D, YYYY')}`
          }
        </span>
      </div>

      {/* If editCardPopup is true, render the EditCardPopup */}
      {showEditPopup && (
        <EditCardPopup
          id={id}
          title={title}
          description={description}
          dueTime={dueTime}
          startTime={startTime}
          onCancel={() => {setShowEditPopup(false); dispatch(setShortTermGoalsConflict(false));}}
          onSubmit={onSubmit}
          onDelete={onDelete}
          setShowEditPopup={setShowEditPopup}
          setPopupVisible={setPopupVisible}
        />
      )}
    </div>
  );
};

// EditCardPopup component
export const EditCardPopup = ({
  id,
  title,
  description,
  dueTime,
  startTime,
  onCancel,
  onSubmit,
  position,
  onDelete,
  setPopupVisible,
  phaseLabel,
  goalLabel,
  startDateLabel,
  endDateLabel,
  deleteText,
  saveText,
  setShowEditPopup,
  isPopupVisibleRef,
}) => {
  const [phaseId, setPhaseID] = useState(id);
  const [phaseTitle, setPhaseTitle] = useState(title);
  const [goalDescription, setGoalDescription] = useState(description);
  const [startDate, setStartDate] = useState(startTime);
  const [endDate, setEndDate] = useState(dueTime);
  const dispatch = useDispatch();

  const conflict = useSelector(selectShortTermGoalsConflict)
  const [internalConf, setInternalConf] = useState(conflict)

  const [form] = Form.useForm();

  useEffect(() => {
    // console.log('sss startTime',title, description, startTime, dueTime)
    form.setFieldsValue({
      phaseId: id,
      phaseTitle: title,
      goalDescription: description,
      startDate: startTime ? moment(startTime, "YYYY-MM-DD") : null,
      endDate: dueTime ? moment(dueTime, "YYYY-MM-DD") : null,
    });
  }, [phaseId, title, description, startTime, dueTime]);

  useEffect(() => {
    console.log('sss STG in useEffect', conflict)
    setInternalConf(conflict)
  }, [conflict])

  // console.log('sss position', position);
  const topPosition = position && position.top ? `${position.top + 40}px` : "-2%";
  const leftPosition = position && position.right ? `${position.right}px ` : "-10%";
  return (
    <div
      ref={isPopupVisibleRef}
      style={{
        padding: "20px",
        backgroundColor: "#fff",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        width: "400px",
        position: "absolute",
        top: topPosition,
        right: leftPosition,
        zIndex: 100,
      }}
    >
      <Form
        form={form}
        name="phase_form"
        onFinish={(values) => {
          dispatch(setShortTermGoalsConflict(false));
          const trimmedValues = {
            ...values,
            phaseTitle: values.phaseTitle?.trim(),
            goalDescription: values.goalDescription?.trim()
          };
          console.log("sss STG sdfsdfbsdb")
          console.log('sss STG asdadas', internalConf)
          if(internalConf){
            console.log('sss STG if', internalConf)
            setShowEditPopup(true)
          }
          else{
            console.log('sss STG else', internalConf)
            onSubmit(trimmedValues); // Call the parent submit handler
            if (setShowEditPopup) {
              setShowEditPopup(false)
            }
          }
        }}
        initialValues={{ phaseTitle, goalDescription, startDate, endDate }}
        layout="vertical"
      >
        {/* Phase ID */}
        <Form.Item label="ID" name="phaseId" hidden> 
          <Input readOnly style={{ padding: "13.5px 11px", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
        </Form.Item>

        {/* Phase Title */}
        <Form.Item label="Phase" name="phaseTitle" rules={[{ required: true, message: "Required Field" }]}> 
          <Input placeholder="Insert Title of Phase" style={{ padding: "13.5px 11px", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
        </Form.Item>

        {/* Goal Description */}
        <Form.Item label="Goal" name="goalDescription" rules={[{ required: true, message: "Required Field" }]}> 
          <TextArea placeholder="Description" style={{ padding: "13.5px 11px", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} autoSize={{ minRows: 1, maxRows: 5 }} />
        </Form.Item>

        {/* Start Date & End Date */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Start Date" name="startDate" rules={[{ required: true, message: "Required Field" }]}> 
              <DatePicker format="MM/DD/YYYY" onChange={() => dispatch(setShortTermGoalsConflict(false))} style={{ padding: "13.5px 11px", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="End Date" name="endDate" rules={[
              { required: true, message: "Required Field" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const startDate = getFieldValue("startDate");
                  if (!value || !startDate || value.isAfter(startDate)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("End Date must be after Start Date"));
                },
              }),
              ]}> 
              <DatePicker format="MM/DD/YYYY" onChange={() => dispatch(setShortTermGoalsConflict(false))} style={{ padding: "13.5px 11px", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
            </Form.Item>
          </Col>
        </Row>
        {
          conflict &&
          <div style={{
            color: "red"
          }}>
            The dates listed above are in conflict with our short-term goals and cannot be synced.
          </div>
        }

        {/* Buttons */}
        <Row justify="space-between">
          <Col span={12}>
          {
            !position ? (

                <button
                  style={{
                    color: "red",
                    textDecoration: "underline",
                    backgroundColor: "white",
                    border: "none",
                    padding: "10px 15px",
                    fontSize: "17px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (onDelete) onDelete(phaseId);
                    if (setShowEditPopup) setShowEditPopup(false);
                    if (setPopupVisible) setPopupVisible(false);
                  }}
                  >
                  {deleteText || "Delete"}
                </button>
            ) : null
          }
          </Col>
          <Col span={12}>
              <Row>
                <Col span={11}>
                <button
                  className="button-secondary"
                  onClick={onCancel} // Call the cancel function passed as prop
                  style={{
                    width: "100%"
                  }}
                >
                  {saveText || "Cancel"}
                </button>
                </Col>
                <Col span={2}></Col>
                <Col span={11}>
                  <button type="submit" 
                    style={{ width: "100%" }} className="button-main">{saveText || "Save"}</button>
                </Col>
              </Row>
          </Col>
        </Row>

      </Form>

    </div>
  );
};

export const EditCardPopup2 = ({
  id,
  description,
  dueTime,
  onCancel,
  onSubmit,
  position,
  deleteText,
  saveText,
  isPopupVisibleRef,
  onDelete
}) => {

  
  const [stepId, setStepID] = useState(id);
  const [stepDescription, setStepDescription] = useState(description);
  const [endDate, setEndDate] = useState(dueTime && !moment.isMoment(dueTime) ? moment(dueTime, "YYYY") : dueTime);
  
  const [form] = Form.useForm();
  
  // useEffect(() => {
  //   console.log('sss EditCardPopup2', id, description, dueTime)
  //   const parsedDueTime = dueTime && !moment.isMoment(dueTime) ? moment(dueTime, "YYYY") : dueTime;
  //   form.setFieldsValue({
  //     stepId: id,
  //     stepDescription: description,
  //     endDate: parsedDueTime,
  //   });
  // }, [description, dueTime, id]);

  // console.log('sss position', position);
  const topPosition = position && position.top ? `${position.top + 40}px` : "-2%";
  const leftPosition = position && position.right ? `${position.right}px ` : "-10%";
  
  return (
    <div
      ref={isPopupVisibleRef}
      style={{
        padding: "20px",
        backgroundColor: "#fff",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        width: "400px",
        position: "absolute",
        top: topPosition,
        right: leftPosition,
        zIndex: 100,
      }}
    >

      <Form
        form={form}
        name="step_form"
        onFinish={onSubmit}
        initialValues={{ stepId, stepDescription, endDate }}
        layout="vertical"
      >
         <Form.Item label="ID" name="stepId" hidden> 
          <Input readOnly style={{ padding: "13.5px 11px", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
        </Form.Item>

        <Form.Item label="Step" name="stepDescription" rules={[{ required: true, message: "Required Field" }]}> 
          <TextArea placeholder="Description" style={{ padding: "13.5px 11px", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} autoSize={{ minRows: 1, maxRows: 5 }} />
        </Form.Item>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Year" name="endDate" rules={[{ required: true, message: "Required Field" }]}> 
              <DatePicker picker="year" format="YYYY" style={{ padding: "13.5px 11px", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="space-between">
          <Col span={12}>
          {
            stepId ? (

                <button
                  style={{
                    color: "red",
                    textDecoration: "underline",
                    backgroundColor: "white",
                    border: "none",
                    padding: "10px 15px",
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                  type="button"
                  onClick={() => {
                    console.log("Delete Clicked")
                    onDelete(stepId)
                  }}
                  >
                  {deleteText || "Delete"}
                </button>
            ) : null
          }
          </Col>
          <Col span={12}>
              <Row>
                <Col span={11}>
                <button
                  className="button-secondary"
                  onClick={onCancel} // Call the cancel function passed as prop
                  style={{
                    width: "100%"
                  }}
                >
                  {saveText || "Cancel"}
                </button>
                </Col>
                <Col span={2}></Col>
                <Col span={11}>
                  <button style={{ width: "100%" }} className="button-main">{saveText || "Save"}</button>
                </Col>
              </Row>
          </Col>
        </Row>

      </Form>

    </div>
  )
}

export default TimelineCardPopup;
